import { useEffect, useState } from "react";
import { PostService } from "../GenericServices/genericService";
import Swal from "sweetalert2";
import { resources_EN } from "../GenericServices/componentUtils";

const UpdateCategoryModal = ({
  showEditCategoryModal,
  categoryData,
  setShowEditCategoryModal,
  getCategoryAPI,
}) => {
  {
    const [formData, setFormData] = useState({});

    useEffect(() => {
      if (categoryData) {
        setFormData(categoryData);
      }
    }, [categoryData]);

    const updateCategoryAPI = () => {
      const url = "myNewAPI/update_category.php";
      PostService(url, formData, modal);
    };

    /* Error or Success Modal */
    const modal = (icon, title, message, response = "") => {
      Swal.fire({
        title: title,
        icon: icon,
        text: message,
      }).then((resp) => {
        if (resp.isConfirmed && icon === resources_EN.success) {
          setShowEditCategoryModal(false);
          setFormData({});
          getCategoryAPI();
        }
      });
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      updateCategoryAPI();
    };

    console.log("Edit Modal Data:", formData);

    return (
      showEditCategoryModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[100] flex items-center justify-center p-4">
          <div className="bg-white rounded-lg p-6 w-full max-w-md">
            <h2 className="text-xl font-bold mb-4">Edit Category</h2>
            <form>
              <input
                type="text"
                placeholder="Category Name"
                value={formData.cat_title}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    cat_name: e.target.value,
                    cat_title: e.target.value,
                  })
                }
                className="w-full mb-4 p-2 border"
                required
              />
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={() => setShowEditCategoryModal(false)}
                  className="mr-4 px-4 py-2 text-gray-600"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  type="button"
                  className="px-4 py-2 bg-blue-600 text-white"
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      )
    );
  }
};

export default UpdateCategoryModal;
